/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetType } from '../models/AssetType';
import type { TAssetId } from '../models/TAssetId';
import type { TCreateAssetResponse } from '../models/TCreateAssetResponse';
import type { TGetAssetResponse } from '../models/TGetAssetResponse';
import type { TGetStorageUsageResponse } from '../models/TGetStorageUsageResponse';
import type { TListAssetsResponse } from '../models/TListAssetsResponse';
import type { TProjectId } from '../models/TProjectId';
import type { TUpdateAssetRequest } from '../models/TUpdateAssetRequest';
import type { TUpdateAssetResponse } from '../models/TUpdateAssetResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AssetService {
    /**
     * Get Asset
     * @param id
     * @param relations
     * @returns TGetAssetResponse TGetAssetResponse
     * @throws ApiError
     */
    public static getAsset(
        id: TAssetId,
        relations?: string,
    ): CancelablePromise<TGetAssetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/assets/{id}',
            path: {
                'id': id,
            },
            query: {
                'relations': relations,
            },
        });
    }
    /**
     * Update Asset
     * @param id
     * @param requestBody
     * @returns TUpdateAssetResponse TUpdateAssetResponse
     * @throws ApiError
     */
    public static updateAsset(
        id: TAssetId,
        requestBody: TUpdateAssetRequest,
    ): CancelablePromise<TUpdateAssetResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/assets/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Asset
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteAsset(
        id: TAssetId,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/assets/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * List Assets
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @param projectId
     * @param type
     * @returns TListAssetsResponse TListAssetsResponse
     * @throws ApiError
     */
    public static listAssets(
        limit?: number,
        page?: number,
        orderAsJsonString?: string,
        relations?: string,
        projectId?: TProjectId,
        type?: AssetType,
    ): CancelablePromise<TListAssetsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/assets',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations,
                'project_id': projectId,
                'type': type,
            },
        });
    }
    /**
     * Create Asset
     * @param formData
     * @returns TCreateAssetResponse TCreateAssetResponse
     * @throws ApiError
     */
    public static createAsset(
        formData: {
            type: string;
            project_id: string;
            name: string;
            description?: string;
            file?: Blob;
        },
    ): CancelablePromise<TCreateAssetResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/assets',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Create Asset from Google Drive
     * @param requestBody
     * @returns TCreateAssetResponse TCreateAssetResponse
     * @throws ApiError
     */
    public static createAssetFromCloud(
        requestBody: {
            provider: 'google';
            description?: string;
            file_id: string;
            name: string;
            project_id: TProjectId;
            type: AssetType;
        },
    ): CancelablePromise<TCreateAssetResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/assets/from-cloud',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @deprecated
     * Create Asset from Google Drive
     * @param requestBody
     * @returns TCreateAssetResponse TCreateAssetResponse
     * @throws ApiError
     */
    public static createAssetFromDrive(
        requestBody: {
            description?: string;
            drive_file_id: string;
            name: string;
            project_id: TProjectId;
            type: AssetType;
        },
    ): CancelablePromise<TCreateAssetResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/assets/from-drive',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Signed Url for Asset File
     * @param id
     * @returns string Ok
     * @throws ApiError
     */
    public static getSignedUrl(
        id: TAssetId,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/assets/signed-url/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get Signed Url for Asset Thumbnail
     * @param id
     * @returns string Ok
     * @throws ApiError
     */
    public static getThumbnailUrl(
        id: TAssetId,
    ): CancelablePromise<string | null> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/assets/thumbnail-url/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get Storage Usage for Group
     * @param groupId
     * @returns TGetStorageUsageResponse Ok
     * @throws ApiError
     */
    public static getStorageUsage(
        groupId: string,
    ): CancelablePromise<TGetStorageUsageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/assets/storage-usage/{group_id}',
            path: {
                'group_id': groupId,
            },
        });
    }
}
